import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import { ImageRetry } from '@components/basics/image-retry';
import SquareCoverIcon from '@components/basics/icons/cover-art';

interface SquareCoverProps {
  className?: string;
  src?: string;
  size?: number;
  alt?: string;
  borderRadius?: number;
}

const SquareCover: FunctionComponent<SquareCoverProps> = ({
  className,
  src,
  alt,
}) => {
  return (
    <div className={className || ''}>
      {src ? (
        <ImageRetry
          className="cover"
          src={src}
          alt={`${alt ? alt : ''} cover art`}
        />
      ) : (
        <SquareCoverIcon className="cover icon" />
      )}
    </div>
  );
};

export default styled(SquareCover)`
  width: ${(props) => (props.size ? `${props.size}px` : '100px')};
  height: ${(props) => (props.size ? `${props.size}px` : '100px')};
  overflow: hidden;
  position: relative;
  border-radius: ${(props) =>
    props.borderRadius ? `${props.borderRadius}px` : '10px'};
  object-fit: cover;
  background-color: ${({ theme }) => theme.colors.secondary};

  .cover {
    max-width: ${(props) => (props.size ? `${props.size}px` : '100px')};
    overflow: hidden;
    object-fit: cover;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &.icon {
      max-width: 65%;
    }
  }
`;
